// Extra presentation data stays on this device; the existing Sheets schema is unchanged.
export const extraKey = apiUrl => `appv2-planner-extras:${apiUrl}`;
export function readExtras(apiUrl) {
  const raw = localStorage.getItem(extraKey(apiUrl));
  if (!raw) return { accounts: [], transferGroups: {}, goals: {} };
  const data = JSON.parse(raw);
  if (!data || !Array.isArray(data.accounts) || !data.goals || !data.transferGroups) {
    throw new Error('ข้อมูลเสริมในเครื่องอ่านไม่ได้ กรุณาสำรองข้อมูลก่อนแก้ไข');
  }
  return data;
}
export function writeExtras(apiUrl, patch) {
  const data = { ...readExtras(apiUrl), ...patch };
  localStorage.setItem(extraKey(apiUrl), JSON.stringify(data));
}
export async function request(apiUrl, action, payload) {
  const response = await fetch(payload === undefined ? `${apiUrl}?action=${action}` : apiUrl,
    payload === undefined ? undefined : { method: 'POST', body: JSON.stringify({ action, ...payload }) });
  if (!response.ok) throw new Error('เชื่อมต่อไม่สำเร็จ กรุณาลองใหม่');
  const result = await response.json();
  if (result.status !== 'success') throw new Error(result.message || 'บันทึกหรือโหลดข้อมูลไม่สำเร็จ');
  return result.data;
}
